// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Page500Component } from '@med/app/errors/components/page-500/page-500.component';
import { Page403Component } from '@med/app/errors/components/page-403/page-403.component';
import { Page404Component } from '@med/app/errors/components/page-404/page-404.component';
import { PATHS } from '@med/utils';

const routes: Routes = [
  {
    path: PATHS.error500,
    component: Page500Component,
    data: {
      title: 'Internal Server Error',
    },
  },
  {
    path: PATHS.error403,
    component: Page403Component,
    data: {
      title: 'Unauthorized',
    },
  },
  {
    path: '**',
    component: Page404Component,
    data: {
      title: 'Page not found',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ErrorsRoutingModule {
}
